export default __webpack_public_path__ + "static/media/iconcy.e8af1fcf.png";